import type {Part} from 'schemaDefinition/types';
import {DefaultPartCompare} from 'schemaDefinition/types';
import type {PartDiffProps} from '../components/types';

export const needsOrignalSubValueContainer = (
  part: Part,
  diff: PartDiffProps,
): boolean => {
  return (
    diff &&
    diff.mode === 'original' &&
    (part.compare ?? diff.outerCompare ?? DefaultPartCompare) === 'subValues'
  );
};
